import { call, put, takeEvery } from 'redux-saga/effects';
import { actions } from '../../utils/constants';

import { fetchTemplateQuestion } from '../../utils/common-functions';

function* asyncFetchQuestionToDuplicate({ payload: { questionId } }) {
    try {
        yield put({
            type: actions.INCREMENT_LOADING_ONLINE_TESTS,
        });

        const response = yield call(fetchTemplateQuestion, { questionId });

        yield put({
            type: actions.CHANGE_QUESTION_TO_DUPLICATE,
            payload: response.data,
        });

        yield put({
            type: actions.DECREMENT_LOADING_ONLINE_TESTS,
        });
    } catch (err) {
        yield put({
            type: actions.DECREMENT_LOADING_ONLINE_TESTS,
        });
        yield put({
            type: actions.REQUEST_ERROR,
            payload: {
                message: err.response.data.error_description,
            },
        });
    }
}

export default function* duplicateQuestion() {
    yield takeEvery(
        actions.ASYNC_FETCH_QUESTION_TO_DUPLICATE,
        asyncFetchQuestionToDuplicate,
    );
}



// WEBPACK FOOTER //
// ./src/components/duplicate-question/duplicate-question.saga.js